
/**
  * 小数加、减、乘、除 保留精度计算
  * @param {Number} value
  * @param {Number} decimals
  * for example
  * precisionRound(0.1 + 0.2, 2) 返回结果0.3
  */
export const precisionRound = (value, decimals) => {
  return Number(`${Math.round(`${value}e${decimals}`)}e-${decimals}`)
}

// 深复制
export const deepCopy = (obj) => {
  let newobj
  if (Object.prototype.toString.call(obj) === '[object Array]') {
    newobj = []
  } else if (Object.prototype.toString.call(obj) === '[object Object]') {
    newobj = {}
  } else {
    newobj = obj
  }

  if (typeof obj !== 'object') {
    return
  }

  for (var key in obj) {
    newobj[key] = typeof obj[key] === 'object' ? deepCopy(obj[key]) : obj[key]
  }
  return newobj
}

export const shallowMerge = (source, target) => {
  const data = deepCopy(target)
  Object.keys(source).forEach((key) => {
    data[key] = source[key]
  })
  return data
}

export const formatDate = (date, fmt = 'yyyy-MM-dd hh:mm:ss') => {
  if (!date) return ''
  const type = Object.prototype.toString.call(date)
  if (!['[object Number]', '[object Date]'].includes(type)) return ''
  if (type === '[object Number]') date = new Date(date * 1000)
  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

/**
 * 根据userAgent获取当前浏览器的版本
 */
export const getBroswer = () => {
  const sys = {}
  const ua = navigator.userAgent.toLowerCase()
  let s
  let res = { broswer: '', version: '0' };

  // eslint-disable-next-line
  (s = ua.match(/mobile/))
    ? (sys.mobile = 1)
    : (s = ua.match(/qqbrowser\/([\d.]+)/)) // eslint-disable-line
      ? (sys.qqbrowser = s[1])
      : (s = ua.match(/edge\/([\d.]+)/)) // eslint-disable-line
        ? (sys.edge = s[1])
        : (s = ua.match(/rv:([\d.]+)\) like gecko/)) // eslint-disable-line
          ? (sys.ie = s[1])
          : (s = ua.match(/msie ([\d.]+)/)) // eslint-disable-line
            ? (sys.ie = s[1])
            : (s = ua.match(/firefox\/([\d.]+)/)) // eslint-disable-line
              ? (sys.firefox = s[1])
              : (s = ua.match(/chrome\/([\d.]+)/)) // eslint-disable-line
                ? (sys.chrome = s[1])
                : (s = ua.match(/opera.([\d.]+)/)) // eslint-disable-line
                  ? (sys.opera = s[1])
                  : (s = ua.match(/version\/([\d.]+).*safari/)) // eslint-disable-line
                    ? (sys.safari = s[1])
                    : 0

  if (sys.mobile) res = { broswer: 'mobile', version: sys.mobile }
  if (sys.qqbrowser) res = { broswer: 'QQBrowser', version: sys.qqbrowser }
  if (sys.edge) res = { broswer: 'Edge', version: sys.edge }
  if (sys.ie) res = { broswer: 'IE', version: sys.ie }
  if (sys.firefox) res = { broswer: 'Firefox', version: sys.firefox }
  if (sys.chrome) res = { broswer: 'Chrome', version: sys.chrome }
  if (sys.opera) res = { broswer: 'Opera', version: sys.opera }
  if (sys.safari) res = { broswer: 'Safari', version: sys.safari }
  return res
}
